<template>
  <b-modal :id="'collaborate-recording-player-' + player_id" centered size="lg" hide-footer no-fade :title="title"
           v-on:shown="onShown" v-on:hidden="clearPlayer">
    <template #default="{ hide }">
      <video-player v-if="videoLoaded" :options="videoOptions" :trackOptions="videoTrackOptions" :chat="chat" :recording="recording" @recording-progress="$emit('recording-progress', $event)"/>
    </template>
  </b-modal>
</template>

<script>
import VideoPlayer from '@/components/Player/VideoPlayer.vue'
import utilitiesMixin from '../../mixins/utilitiesMixin'
import ltiFrameMixin from '../../mixins/ltiFrameMixin'

export default {
  name: 'RecordingVideoPlayer',
  components: {
    VideoPlayer
  },
  mixins: [utilitiesMixin, ltiFrameMixin],
  props: ['player_url', 'title', 'captions_url', 'player_id', 'chat', 'captions_language', 'recording'],
  data () {
    return {
      videoLoaded: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        fluid: true,
        language: 'es',
        sources: [
          {
            src: null,
            type: 'video/mp4'
          }
        ]
      },
      videoTrackOptions: {
        kind: null,
        label: null,
        language: null,
        src: null
      }
    }
  },
  methods: {
    onShown () {
      this.initPlayer()
      // El anclado se hace después de que el vídeo esté en el DOM: hasta entonces el
      // modal está vacío y su altura no es la definitiva.
      //
      // Con setTimeout y no con requestAnimationFrame: Chrome estrangula el rAF de los
      // iframes que quedan fuera de pantalla, que es justo la situación que estamos
      // corrigiendo. getBoundingClientRect fuerza el cálculo de estilos, así que no
      // hace falta esperar a un repintado para medir.
      this.$nextTick(() => window.setTimeout(() => {
        this.anchorLtiModalToClick('collaborate-recording-player-' + this.player_id)
      }, 0))
    },
    initPlayer () {
      let labelCaptions = 'Español'
      let languageCaptions = 'es'
      let languageOptions = this.languageOptions()
      for (var i = 1; i < languageOptions.length; i++) {
        if (languageOptions[i].value === this.captions_language) {
          labelCaptions = languageOptions[i].text
          languageCaptions = languageOptions[i].value.substring(0, 2)
        }
      }
      this.videoOptions = {
        autoplay: true,
        controls: true,
        fluid: true,
        language: languageCaptions,
        sources: [
          {
            src: this.player_url,
            type: 'video/mp4'
          }
        ]
      }
      this.videoTrackOptions = {
        kind: 'captions',
        label: labelCaptions,
        language: languageCaptions,
        src: this.captions_url
      }
      this.videoLoaded = true
    },
    clearPlayer () {
      this.videoLoaded = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Player/RecordingVideoPlayer.vue